import { useTranslation } from 'react-i18next'
import { ListProjectFragment, User } from '../../../generated/graphql'
import { formatDate } from '../../common/util/date-util'
import { calculateArea } from './project-util'

export enum ProjectListKeys {
  Id = 'id',
  ProjectId = 'projectId',
  Name = 'name',
  Area = 'area',
  Updated = 'updated',
  Created = 'created',
  LicensePaid = 'licensePaid',
}

export type ProjectListData = {
  id: string
  projectId: string
  name: string
  area: number
  updated: string
  created: string
  licensePaid: boolean
}

type UseProjectListData = {
  keyTranslations: Record<ProjectListKeys, string>
  mapProjectToListData: (project: ListProjectFragment) => ProjectListData
}

export function useProjectListData(): UseProjectListData {
  const { t } = useTranslation()

  const keyTranslations: Record<ProjectListKeys, string> = {
    id: 'Id',
    projectId: t('projects.tableHeaderProjectId'),
    name: t('projects.tableHeaderName'),
    area: t('projects.tableHeaderArea'),
    updated: t('projects.tableHeaderUpdated'),
    created: t('projects.tableHeaderCreated'),
    licensePaid: t('projects.tableHeaderLicensePaid'),
  }

  const formatDateAndName = (
    isoDate: string,
    user: Pick<User, 'displayName'>,
  ) => `${formatDate(new Date(isoDate), t('date.short'))} | ${user.displayName}`

  const mapProjectToListData = (
    project: ListProjectFragment,
  ): ProjectListData => ({
    id: project.id,
    projectId: project.projectId,
    name: project.name,
    area: calculateArea(project),
    updated: formatDateAndName(project.updatedAt, project.updatedBy),
    created: formatDateAndName(project.createdAt, project.owner),
    licensePaid: project.licensePaid,
  })

  return {
    keyTranslations,
    mapProjectToListData,
  }
}
